import { Component, Host, Optional, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Route, Router, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MpsUserService } from '../../services/mps-user.service';
import { MpsPermissionHelper } from '../../helpers/mps-permission.helper';

@Component({
  selector: 'mps-app-navigation',
  templateUrl: './mps-navigation.component.html',
  styleUrls: ['./mps-navigation.component.scss'],
  imports: [TranslateModule, MatMenuModule, RouterModule],
})
export class MpsNavigationComponent {
  private readonly _routes: Route[] = [];
  private _userService = inject(MpsUserService);

  constructor(@Host() @Optional() private _sidenav: MatSidenav, _router: Router) {
    this._routes = _router.config;
  }

  public getRoutes(): Route[] {
    return this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }

  isMenuItemDisplayed(route: Route) {
    const user = this._userService.getUserSubject().getValue();
    if (!user) {
      return false;
    }

    const hasTitle = route.data?.['title'];
    const canUserActivate = MpsPermissionHelper.canUserActivate(user, route);
    return hasTitle && canUserActivate;
  }
}
